import script from "./LedgerDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LedgerDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./LedgerDetailsModal.vue?vue&type=style&index=0&id=c6c3f2c6&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6c3f2c6"]])

export default __exports__